/**
 * Cookie Patcher for Iframe Support
 *
 * This module patches the js-cookie library to automatically add
 * SameSite=None and Secure attributes to all cookies set by the Stack SDK.
 * This is necessary for authentication to work in iframe contexts where
 * third-party cookies are blocked by default.
 *
 * IMPORTANT: This must be imported BEFORE any Stack SDK imports.
 */

import Cookies from 'js-cookie';

// Store the original set method
const originalSet = Cookies.set.bind(Cookies);

// Override the set method to always include SameSite=None and Secure
Cookies.set = function (
  name: string,
  value: string,
  options?: Cookies.CookieAttributes
) {
  const patchedOptions: Cookies.CookieAttributes = {
    ...options,
    sameSite: 'None',
    secure: true,
  };

  return originalSet(name, value, patchedOptions);
} as typeof Cookies.set;

console.log('[CookiePatcher] js-cookie has been patched for iframe support');

export {};
